import React from "react";
import { cleanJoin } from "../../utils/stringUtil";

export default function Level({ className, children, ...rest }) {
  return (
    <div className={cleanJoin("level", className)} {...rest}>
      {children}
    </div>
  );
}
